import { PowerResourceType } from '@/contract/map.base'
import { cur, fxResource } from '@/utils/env'
import { ZoomMode } from '../../contract/map'

export const ResourceIconMap = {
  // 地图上icon
  [PowerResourceType.PowerSwap]: (process.config as any).resourceIcon.PowerSwap.noSelected.replace(
    '${fxResource}',
    fxResource
  ),
  [PowerResourceType.ChargeStation]: (
    process.config as any
  ).resourceIcon.ChargeStation.noSelected.replace('${fxResource}', fxResource),
  [PowerResourceType.NioChargeStationNpc]: (
    process.config as any
  ).resourceIcon.NioChargeStationNpc.noSelected.replace('${fxResource}', fxResource),
  [PowerResourceType.NioChargeStationDest]: (
    process.config as any
  ).resourceIcon.NioChargeStationDest.noSelected.replace('${fxResource}', fxResource),
  [PowerResourceType.ThirdChargeStation]: (
    process.config as any
  ).resourceIcon.ThirdChargeStation.noSelected.replace('${fxResource}', fxResource),
  [PowerResourceType.NioSpace]: (process.config as any).resourceIcon.NioHouse.noSelected.replace(
    '${fxResource}',
    fxResource
  ),
  [PowerResourceType.NioHouse]: (process.config as any).resourceIcon.NioHouse.noSelected.replace(
    '${fxResource}',
    fxResource
  ),
  [PowerResourceType.NioRoadShow]: (process.config as any).resourceIcon.NioHouse.noSelected.replace(
    '${fxResource}',
    fxResource
  ),
  [PowerResourceType.TestDrive]: (process.config as any).resourceIcon.TestDrive.noSelected.replace(
    '${fxResource}',
    fxResource
  ),
  [PowerResourceType.ServiceCenter]: (
    process.config as any
  ).resourceIcon.ServiceCenter.noSelected.replace('${fxResource}', fxResource),
  [PowerResourceType.Merged]: '',
  [PowerResourceType.Unknown]: '',
}

export const ResourceIconMapUpgrade =
  'https://cdn-fx.nio.com/fx/pe-h5pages-fe-alps/__cdn__/resource_icon/swap_upgrade_v2.svg'

export const ResourceSelectedIconMapUpgrade =
  'https://cdn-fx.nio.com/fx/pe-h5pages-fe-alps/__cdn__/resource_icon/swap_selected_upgrade_v2.svg'

export const ResourceSelectedIconMap = {
  // 地图上pin点 - 选中
  [PowerResourceType.PowerSwap]: (process.config as any).resourceIcon.PowerSwap.selected.replace(
    '${fxResource}',
    fxResource
  ),
  [PowerResourceType.ChargeStation]: (
    process.config as any
  ).resourceIcon.ChargeStation.selected.replace('${fxResource}', fxResource),
  [PowerResourceType.NioChargeStationNpc]: (
    process.config as any
  ).resourceIcon.NioChargeStationNpc.selected.replace('${fxResource}', fxResource),
  [PowerResourceType.NioChargeStationDest]: (
    process.config as any
  ).resourceIcon.NioChargeStationDest.selected.replace('${fxResource}', fxResource),
  [PowerResourceType.ThirdChargeStation]: (
    process.config as any
  ).resourceIcon.ThirdChargeStation.selected.replace('${fxResource}', fxResource),
  [PowerResourceType.NioSpace]: (process.config as any).resourceIcon.NioHouse.selected.replace(
    '${fxResource}',
    fxResource
  ),
  [PowerResourceType.NioHouse]: (process.config as any).resourceIcon.NioHouse.selected.replace(
    '${fxResource}',
    fxResource
  ),
  [PowerResourceType.NioRoadShow]: (process.config as any).resourceIcon.NioHouse.selected.replace(
    '${fxResource}',
    fxResource
  ),
  [PowerResourceType.TestDrive]: (process.config as any).resourceIcon.TestDrive.selected.replace(
    '${fxResource}',
    fxResource
  ),
  [PowerResourceType.ServiceCenter]: (
    process.config as any
  ).resourceIcon.ServiceCenter.selected.replace('${fxResource}', fxResource),
  [PowerResourceType.Merged]: '',
  [PowerResourceType.Unknown]: '',
}

export const ResourceRoutePlanIconMap = {
  // 路径规划上的点
  [PowerResourceType.PowerSwap]: (process.config as any).resourceIcon.PowerSwap.selected.replace(
    '${fxResource}',
    fxResource
  ),
  [PowerResourceType.ChargeStation]: (
    process.config as any
  ).resourceIcon.ChargeStation.selected.replace('${fxResource}', fxResource),
  [PowerResourceType.NioChargeStationNpc]: (
    process.config as any
  ).resourceIcon.NioChargeStationNpc.selected.replace('${fxResource}', fxResource),
  [PowerResourceType.NioChargeStationDest]: (
    process.config as any
  ).resourceIcon.NioChargeStationDest.selected.replace('${fxResource}', fxResource),
  [PowerResourceType.ThirdChargeStation]: (
    process.config as any
  ).resourceIcon.ThirdChargeStation.selected.replace('${fxResource}', fxResource),
  [PowerResourceType.Merged]: '',
  [PowerResourceType.Unknown]: '',
}

export const ResourceRoutePlanIconPointMap = {
  // 路径规划上候选点
  // [PowerResourceType.PowerSwap]: `https://cdn-power-public${cur}.nio.com/pe-fe-statics/pe/ns/h5/swap_point.png`,
  // [PowerResourceType.ChargeStation]: `https://cdn-power-public${cur}.nio.com/pe-fe-statics/pe/ns/h5/powercharger_point.png`,
  // [PowerResourceType.NioChargeStationNpc]: `https://cdn-power-public${cur}.nio.com/pe-fe-statics/pe/ns/h5/powercharger_point.png`,
  // [PowerResourceType.NioChargeStationDest]: `https://cdn-power-public${cur}.nio.com/pe-fe-statics/pe/ns/h5/powercharger_point.png`,
  // [PowerResourceType.ThirdChargeStation]: `https://cdn-power-public${cur}.nio.com/pe-fe-statics/pe/ns/h5/powercharger_point.png`,
  [PowerResourceType.PowerSwap]: (process.config as any).resourceIconDot.PowerSwap.replace(
    '${fxResource}',
    fxResource
  ),
  [PowerResourceType.ChargeStation]: (process.config as any).resourceIconDot.ChargeStation.replace(
    '${fxResource}',
    fxResource
  ),
  [PowerResourceType.NioChargeStationNpc]: (
    process.config as any
  ).resourceIconDot.ChargeStation.replace('${fxResource}', fxResource),
  [PowerResourceType.NioChargeStationDest]: (
    process.config as any
  ).resourceIconDot.ChargeStation.replace('${fxResource}', fxResource),
  [PowerResourceType.ThirdChargeStation]: (
    process.config as any
  ).resourceIconDot.ChargeStation.replace('${fxResource}', fxResource),
  [PowerResourceType.Merged]: '',
  [PowerResourceType.Unknown]: '',
}

export const ResourceStandbyIndexMap = {
  [PowerResourceType.PowerSwap]: 10,
  [PowerResourceType.NioChargeStationNpc]: 9,
  [PowerResourceType.NioChargeStationDest]: 8,
  [PowerResourceType.ThirdChargeStation]: 7,
  [PowerResourceType.Merged]: 10,
  [PowerResourceType.Unknown]: 10,
}

export const ResourceIndexMap = {
  [PowerResourceType.ServiceCenter]: 20,
  [PowerResourceType.TestDrive]: 19,
  [PowerResourceType.NioSpace]: 16,
  [PowerResourceType.NioHouse]: 17,
  [PowerResourceType.NioRoadShow]: 18,
  [PowerResourceType.PowerSwap]: 15,
  [PowerResourceType.NioChargeStationNpc]: 14,
  [PowerResourceType.NioChargeStationDest]: 13,
  [PowerResourceType.ThirdChargeStation]: 12,
  [PowerResourceType.Merged]: 16,
  [PowerResourceType.Unknown]: 16,
}

export const ResourceIconSizeMap = {
  [ZoomMode.Country]: { width: 6, height: 6 },
  [ZoomMode.Route]: { width: 40, height: 40 },
  [ZoomMode.City]: { width: 40, height: 40 },
}

export const ResourceIconMapVgl = ResourceIconMap
